import { createFileRoute } from '@tanstack/react-router';

import { ZonesIndexPage } from '../modules/zones/ui/pages/ZonesIndexPage';

export const Route = createFileRoute('/_authenticated/dashboard/locations/$locationId/zones/')({
  component: ZonesIndexPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Zones'],
  },
});
